import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const MaterialForm = props => {
  const [form] = Form.useForm();
  const [materialTypes, setMaterialTypes] = useState([]);
  const { t } = useTranslation();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Load material types
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/material-types")
      .then(({ data }) => {
        setMaterialTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        materialType: props.record.asset.materialType,
        value: props.record.asset.value,
        quantity: props.record.asset.quantity
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        materialType: props.record.asset.materialType,
        value: props.record.asset.value,
        quantity: props.record.asset.quantity
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;

    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.value = elvis(values.value);
    newAsset.asset.quantity = elvis(values.quantity);
    newAsset.asset.materialType = elvis(values.materialType);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title
        className="details_form_header"
        title="Asset details"
        subTitle="Stock - Stored Inputs"
      />

      <Form.Item
        label="Type"
        name="materialType"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {materialTypes.map(name => (
            <Option key={name} value={name}>
              {t("farmEnums.material_type." + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Value (€)"
        name="value"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Quantity (kg)"
        name="quantity"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default MaterialForm;